import api from "../api/axios";

const expenseService = {
  getAll: () => api.get("/expense/get-all"),
  getById: (id) => api.get(`/expense/get/${id}`),
  create: (data) => api.post("/expense/create", data),
  update: (data) => api.post("/expense/update", data),
  delete: (id) => api.delete(`/expense/delete/${id}`),
};

export default expenseService;
